// extracted by mini-css-extract-plugin
module.exports = {"support":"EventPage_support__4B0qA","iframeContainer":"EventPage_iframeContainer__kSiWX","eventHead":"EventPage_eventHead__uop7c"};